import {
  makeAutoObservable,
  observable,
  action,
  computed,
  runInAction,
  toJS,
  autorun,
  onBecomeUnobserved,
  reaction,
} from "mobx";
import { commonAxios } from "../../pages/ExperianPage/CommonAxios";
import { CommonPathWay } from "../../Components/CommonPathWay";
import { showAlertToast } from "../../Components/ToastComponent/AlertMessage.js";
class SubscriptionConfigStore {
  tableData = {
    options: [],
  };
  pageSize = 10;
  currentPage = 1;
  totalPages = 1;
  searchInput = "";
  credits = "";
  expiry = "";
  plan = "";
  planModalShow = false;
  labelErrorMessage = null;
  formSubmitMessageFlag = false;
  allocatedCredits = 1;
  allocateCreditsModalShow = false;
  ShowCreditModal = false;
  selectedRow = null;
  inforBarMessage = "";
  inforBarMessageFlag = false;
  inactiveModalShow = false;
  activateuserModalShow = false;
  statusOfUser = "";
  userRole = "";
  updatePlanValue = "";
  calendarValue = {
    startDate: new Date(
      new Date().setDate(new Date().getDate() - 7)
    ).toLocaleDateString("en-CA"),
    endDate: new Date().toLocaleDateString("en-CA"),
  };
  constructor(rootstore) {
    this.rootstore = rootstore;
    makeAutoObservable(this);
    reaction(
      () => [
        this.pageSize,
        this.currentPage,
        this.searchInput,
        this.calendarValue.startDate,
        this.calendarValue.endDate,
      ],
      () => {
        this.searchFunction();
      }
    );
  }
  handleManageUser = async () => {
    await this.searchFunction();
  };

  setCalendarValue = (value) => {
    this.calendarValue = value;
  };
  getuserdetails = async () => {
    try {
      const response = await commonAxios("/getProfile", "GET", {
        userId: this.UserId,
      });
      runInAction(() => {
        this.userRole = response.data.activeRole;
      });
    } catch (error) {}
  };

  searchFunction = async () => {
    try {
      const response = await CommonPathWay(
        "/subscription/list",
        "GET",
        {},
        {
          limit: this.pageSize,
          page: this.currentPage,
        }
      );
      if (response?.data) {
        runInAction(() => {
          this.tableData = response?.data;
          // this.pageSize = response.data?.pagination?.limit || 10;
          // this.currentPage = response.data?.pagination.page || 1;
          // this.totalPages = response.data?.pagination?.totalPages;
        });
      }
    } catch (e) {
      console.error("User fetch failed:", e);
    }
  };

  handlePlanAdd = async (e) => {
    e.preventDefault();
    const isValid =
      !this.credits ||
      !this.plan ||
      !this.expiry ||
      this.credits === "" ||
      this.expiry === "" ||
      this.plan === "";
    if (isValid) {
      this.setLabelErrorMessage("Please fill all the fields");
      showAlertToast({
        title: "Plan Create",
        message: "Please fill all the fields",
        type: "warning",
      });
      return;
    }
    try {
      const response = await CommonPathWay(
        "/subscription/create",
        "POST",
        {},
        {
          credits: this.credits,
          price: this.plan,
          expiry: this.expiry,
          type: (this.plan === "Free" && this.credits === 500) ? "free"  : "subscription"
        }
      );
      showAlertToast({
        title: "Plan Create",
        message: "Plan Created successfully",
        type: "success",
      });
      this.setFormSubmitMessageFlag(true);
      this.setLabelErrorMessage(null);
      this.setCredits("");
      this.setPlan("");
      this.setExpiry("");
      this.setPlanModalShow(false);
      this.searchFunction();
    } catch (e) {
      showAlertToast({
        title: "Plan Create",
        message: e?.response?.data?.error?.message || "Something went wrong",
        type: "error",
      });
    }
  };

  handlePlanEdit = async (e) => {
    e.preventDefault();
    try {
      const response = await CommonPathWay(
        "/subscription/update",
        "PATCH",
        {},
        {
          planId: this.selectedRow?._id,
          plan: {
            credits: this.credits,
            price: this.plan,
            expiry: this.expiry,
            type: (this.plan === "Free" && this.credits === 500) ? "free"  : "subscription"
          },
        }
      );

      if (response?.success) {
        runInAction(() => {
          this.setLabelErrorMessage(null);
          this.setPlanModalShow(false);
          this.setSelectedRow("");
          this.setCredits("");
          this.setPlan("");
          this.setExpiry("");
        });
        showAlertToast({
          type: "success",
          message: "Plan Updated Successfully",
          title: "UPDATE PLAN",
        });
        this.searchFunction();
      } else {
        throw new Error("Unexpected response format");
      }
    } catch (e) {
      showAlertToast({
        type: "error",
        message: e?.response?.data?.error?.message || "Something went wrong",
        title: "Update Plan Failed",
      });
    }
  };

  handleInacticvePlan = async () => {
    try {
      const response = await CommonPathWay(
        "/subscription/update",
        "PATCH",
        {},
        {
          planId: this.selectedRow?._id,
          plan: {
            status:  this.updatePlanValue === "inactive" ? "active" : "inactive",
          },
        }
      );
      if (!response?.success) {
        showAlertToast({
          type: "error",
          message: e?.response?.data?.error?.message || "Something went wrong",
          title: "Plan Inactive",
        });
        runInAction(() => {
          this.setInactiveModalShow(false);
          this.updatePlanValue = "";
        });
      } else {
        showAlertToast({
          type: "success",
          message: "Plan Inactive Successfully",
          title: "Plan Inactive",
        });
        runInAction(() => {
          this.setInactiveModalShow(false);
        });
      }
    } catch (e) {
      showAlertToast({
        type: "error",
        message: e?.response?.data?.error?.message,
        title: "Plan Inactive",
      });
    }
  };
  handleActivateUser = async () => {
    try {
      const response = await commonAxios(
        "/removeUser",
        "POST",
        {},
        {
          memberId: this.selectedRow?.userId,
          status: this.statusOfUser,
        }
      );
      showAlertToast({
        type: "success",
        message: "User Activate Successfully",
        title: "User Activated",
      });
      runInAction(() => {
        this.setActivateModalShow(false);
      });
    } catch (e) {
      showAlertToast({
        type: "error",
        message: e?.response?.data?.error?.message,
        title: "User Activation",
      });
    }
  };
  handleShowcredits = async (value) => {
    try {
      const response = await commonAxios(
        "/hideCredit",
        "POST",
        {},
        {
          memberId: this.selectedRow?.userId,
          status: value,
        }
      );
      showAlertToast({
        type: "success",
        message: "Show Credits status updatted",
        title: "Show Credits",
      });
      runInAction(() => {
        this.setShowCreditModal(false);
        this.handleManageUser();
      });
    } catch (e) {
      showAlertToast({
        type: "error",
        message: e?.response?.data?.error?.message,
        title: "Show Credits",
      });
    }
  };
  handleOptionClick = (row, option) => {
    if (option.label === "Credit Visibility") {
      this.setShowCreditModal(true);
      this.setSelectedRow(row);
    }
    if (option.label === "Allocate Credits") {
      this.setAllocateCreditsModalShow(true);
      this.setSelectedRow(row);
    }
    if (option.label === "Remove User") {
      // this.setInactiveModalShow(true);
      this.setSelectedRow(row);
      this.statusOfUser = option.type;
    }
    if (option.label === "Activate User") {
      this.setActivateModalShow(true);
      this.setSelectedRow(row);
      this.statusOfUser = option.type;
    }
    if (option.label === "Update") {
      runInAction(() => {
        this.updatePlanValue = option.type;
        this.setSelectedRow(row);
        this.setCredits(row.credits);
        this.setPlan(row.price);
        this.setExpiry(row.expiry);
        this.setPlanModalShow(true);
      });
    }
    if (option.label === "In Active") {
      runInAction(() => {
        this.setSelectedRow(row);
        this.setInactiveModalShow(true);
        this.updatePlanValue = option.type;
      });
      console.log(this.updatePlanValue, "this.updatePlanValue");
    }
  };
  setUpdatePlanValue = (value) => {
    this.updatePlanValue = value;
  };
  setSearchInput = (value) => {
    this.searchInput = value;
  };
  setPageSize = (size) => {
    this.pageSize = size;
  };
  setCurrentPage = (page) => {
    if (page < 0) {
      this.currentPage = 0;
    } else {
      this.currentPage = page;
    }
  };
  setExpiry = (value) => {
    this.expiry = value;
  };
  setCredits = (value) => {
    this.credits = value;
  };
  setPlan = (value) => {
    this.plan = value;
  };
  setPlanModalShow = (value) => {
    this.planModalShow = value;
  };
  setLabelErrorMessage = (value) => {
    this.labelErrorMessage = value;
  };
  setFormSubmitMessageFlag = (value) => {
    this.formSubmitMessageFlag = value;
  };
  setAllocatedCredits = (value) => {
    if (value <= 0 && value !== "") {
      showAlertToast({
        type: "warning",
        title: "Credit Allocation",
        message: "Please enter greater than one",
      });
      return;
    }
    this.allocatedCredits = value;
  };
  setAllocateCreditsModalShow = (value) => {
    this.allocateCreditsModalShow = value;

    if (value) {
      this.allocatedCredits = 1;
    }
  };
  setShowCreditModal = (value) => {
    runInAction(() => {
      this.ShowCreditModal = value;
    });
  };

  setSelectedRow = (row) => {
    this.selectedRow = row;
  };
  setInforBarMessage = (message) => {
    this.inforBarMessage = message;
  };
  setInforBarMessageFlag = (flag) => {
    this.inforBarMessageFlag = flag;
  };
  setInactiveModalShow = (value) => {
    this.inactiveModalShow = value;
  };
  setActivateModalShow = (value) => {
    this.activateuserModalShow = value;
  };
}
export default SubscriptionConfigStore;
